export enum VideoPlayerState {
    Idle = 'Idle',
    Playing = 'Playing',
    Paused = 'Paused',
    Ended = 'Ended',
    Error = 'Error',
    Buffering = 'Buffering'
}

export type VideoPlayerStatus = {
    seconds: number;
    percent: number;
    duration: number;
};

export type VideoPlayerError = {
    message?: string;
    method?: string;
    name: 'NotAllowedError' | 'UnknownError';
};
